import { useSyncExternalStore } from 'react';
const STORAGE_KEY = 'genesis.settings.v1';
const DEFAULTS = {
    theme: 'system',
    autoRefreshMinutes: 0,
    slaMinutes: 60,
    urgencyPulse: true,
};
let cached = null;
const listeners = new Set();
function read() {
    if (cached)
        return cached;
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        const parsed = raw ? JSON.parse(raw) : {};
        cached = {
            ...DEFAULTS,
            ...parsed,
            slaMinutes: Number.isFinite(Number(parsed.slaMinutes)) && Number(parsed.slaMinutes) > 0
                ? Number(parsed.slaMinutes)
                : DEFAULTS.slaMinutes,
        };
    }
    catch {
        cached = { ...DEFAULTS };
    }
    return cached;
}
export function getAppSettings() {
    return read();
}
export function updateAppSettings(patch) {
    const next = { ...read(), ...patch };
    cached = next;
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    }
    catch {
        /* private mode — keep in-memory */
    }
    applyTheme(next.theme);
    for (const fn of listeners)
        fn();
    return next;
}
function subscribe(fn) {
    listeners.add(fn);
    return () => listeners.delete(fn);
}
/** React hook — re-renders when any setting changes. */
export function useAppSettings() {
    return useSyncExternalStore(subscribe, read, read);
}
/* ---------------------------------------------------------------- theme */
function systemPrefersDark() {
    return (typeof window !== 'undefined' &&
        window.matchMedia?.('(prefers-color-scheme: dark)').matches);
}
export function applyTheme(pref = read().theme) {
    const dark = pref === 'dark' || (pref === 'system' && systemPrefersDark());
    document.documentElement.classList.toggle('dark', dark);
}
/** Call once at boot: applies saved theme and tracks OS changes. */
export function initAppTheme() {
    applyTheme();
    window
        .matchMedia?.('(prefers-color-scheme: dark)')
        .addEventListener?.('change', () => {
        if (read().theme === 'system')
            applyTheme('system');
    });
}
